export default function Loader({ className }) {
  return (
    <div className={className}>
      <div className="lds-dual-ring"></div>
    </div>
  );
}
